import styled from 'styled-components';

import { Button, minWidth, units } from '@calm-web/design-system';

export const PurchaseFormSectionWrapper = styled.div`
	background: white;
	margin-bottom: 20px;
	border-radius: 20px;
	width: 100%;
	padding: 20px;

	> p {
		margin-bottom: 20px;
	}

	${minWidth('desktop')} {
		padding: 48px;
	}
`;

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	max-height: 25px;
	gap: ${units(1)};
`;

export const TextWrapper = styled.div`
	margin: 0.75rem 0;
	text-align: center;
`;

export const Wrapper = styled.form`
	padding: 20px 0;
`;

export const SubmitButton = styled(Button)`
	margin-top: 1rem;
`;

export const ExpressCheckoutWrapper = styled.div`
	margin: 0.75rem 0;
`;
